// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__24drx","form":"styles_form__1Nf5L"};